import Home from "./components/Home";
import './assets/css/style.css';
import './assets/css/style-preset.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Dashboard from "./components/layout/Dashboard";
import Login from "./components/auth/Login";
import UserList from "./components/users/UserList";
import AddUser from "./components/users/AddUser";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ProtectedRoutes from "./components/Routes/ProtectedRoutes";
import SupportList from "./components/Support/SupportList";
import Profile from "./components/auth/Profile";
import UserDetails from "./components/users/UserDetails";
import UserUpdate from "./components/users/UserUpdate";
import NotFound from "./components/Page404/NotFound";
import CmsList from "./components/CMS/CmsList";
import CmsDetails from "./components/CMS/CmsDetails";
import CmsAdd from "./components/CMS/CmsAdd";
import CmsUpdate from "./components/CMS/CmsUpdate";
import FAQList from "./components/FAQs/FAQList";
import AddFAQs from "./components/FAQs/AddFAQs";
import ViewFAQs from "./components/FAQs/ViewFAQs";
import EditFAQs from "./components/FAQs/EditFAQs";
import CategoryList from "./components/Category/CategoryList";
import AddCategory from "./components/Category/AddCategory";
import CategoryView from "./components/Category/CategoryView";
import CategoryUpdate from "./components/Category/CategoryUpdate";
import TestiList from "./components/Testimonials/TestiList";
import AddTesti from "./components/Testimonials/AddTesti";
import ViewTesti from "./components/Testimonials/ViewTesti";
import UpdateTesti from "./components/Testimonials/UpdateTesti";
import AddBanner from "./components/Banner/AddBanner";
import ProductList from "./components/Products/ProductList";
import AddProduct from "./components/Products/AddProduct";
import ProductDetails from "./components/Products/ProductDetails";
import ProductEdit from "./components/Products/ProductEdit";
import FooterInfoUpdate from "./components/FooterInfo/FooterInfoUpdate";
import NewsLettersList from "./components/NewsLetters/NewsLettersList";
import CouponList from "./components/Coupons/CouponList";
import CouponAdd from "./components/Coupons/CouponAdd";
import CouponDetails from "./components/Coupons/CouponDetails";
import CouonUpdate from "./components/Coupons/CouonUpdate";
import UpdateShippingSetting from "./components/ShippingSetting/UpdateShippingSetting";
import OrderList from "./components/Orders/OrderList";
import OrderDetails from "./components/Orders/OrderDetails";
import UpdateAbout from "./components/AboutManage/UpdateAbout";
import AllContactMessages from "./components/Contacts/AllContactMessages";


function App() {
  return (
    <>
      {/* <h1>!! Jai Shree Ram !!</h1> */}
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<NotFound />} />
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoutes component={Dashboard} />}>
            <Route index element={<ProtectedRoutes component={Home} />} />
            <Route path="/profile" element={<ProtectedRoutes component={Profile} />} />

            {/* user/creator management start */}
            <Route path="/users/user-list" element={<ProtectedRoutes component={UserList} />} />
            <Route path="/users/add-user" element={<ProtectedRoutes component={AddUser} />} />
            <Route path="/users/view-user/:id" element={<ProtectedRoutes component={UserDetails} />} />
            <Route path="/users/update-user/:id" element={<ProtectedRoutes component={UserUpdate} />} />

            {/* Support management start */}
            <Route path="/support/support-list" element={<ProtectedRoutes component={SupportList} />} />
            {/* Support management end */}

            {/* faqs management start */}
            <Route path="/faqs/faq-list" element={<ProtectedRoutes component={FAQList} />} />
            <Route path="/faqs/add-faq" element={<ProtectedRoutes component={AddFAQs} />} />
            <Route path="/faqs/view-faq/:id" element={<ProtectedRoutes component={ViewFAQs} />} />
            <Route path="/faqs/update-faq/:id" element={<ProtectedRoutes component={EditFAQs} />} />
            {/* faqs management end */}

            {/* CMS management start */}
            <Route path="/cms/cms-list" element={<ProtectedRoutes component={CmsList} />} />
            <Route path="/cms/add-cms" element={<ProtectedRoutes component={CmsAdd} />} />
            <Route path="/cms/view-cms/:slug" element={<ProtectedRoutes component={CmsDetails} />} />
            <Route path="/cms/update-cms/:slug" element={<ProtectedRoutes component={CmsUpdate} />} />
            {/* CMS management end */}

            {/* Category management start */}
            <Route path="/categories/category-list" element={<ProtectedRoutes component={CategoryList} />} />
            <Route path="/categories/add-category" element={<ProtectedRoutes component={AddCategory} />} />
            <Route path="/categories/view-category/:id" element={<ProtectedRoutes component={CategoryView} />} />
            <Route path="/categories/update-category/:id" element={<ProtectedRoutes component={CategoryUpdate} />} />
            {/* Category management end */}

            {/* Testimonials management start */}
            <Route path="/testimonials/testimonial-list" element={<ProtectedRoutes component={TestiList} />} />
            <Route path="/testimonials/add-testimonial" element={<ProtectedRoutes component={AddTesti} />} />
            <Route path="/testimonials/view-testimonial/:id" element={<ProtectedRoutes component={ViewTesti} />} />
            <Route path="/testimonials/update-testimonial/:id" element={<ProtectedRoutes component={UpdateTesti} />} />
            {/* Testimonials management end */}

            {/* products management start */}
            <Route path="/products/product-list" element={<ProtectedRoutes component={ProductList} />} />
            <Route path="/products/add-product" element={<ProtectedRoutes component={AddProduct} />} />
            <Route path="/products/view-product/:id" element={<ProtectedRoutes component={ProductDetails} />} />
            <Route path="/products/update-product/:id" element={<ProtectedRoutes component={ProductEdit} />} />
            {/* products management end */}

            {/* coupon management start */}
            <Route path="/coupons/coupon-list" element={<ProtectedRoutes component={CouponList} />} />
            <Route path="/coupons/add-coupon" element={<ProtectedRoutes component={CouponAdd} />} />
            <Route path="/coupons/view-coupon/:code" element={<ProtectedRoutes component={CouponDetails} />} />
            <Route path="/coupons/update-coupon/:id" element={<ProtectedRoutes component={CouonUpdate} />} />
            {/* products management end */}

            {/* Banner management start */}
            <Route path="/banner/update-banner" element={<ProtectedRoutes component={AddBanner} />} />
            {/* Banner management end */}

            {/* shipping management start */}
            <Route path="/shipping/update-shipping" element={<ProtectedRoutes component={UpdateShippingSetting} />} />
            {/* shipping management end */}

            {/* Footer management start */}
            <Route path="/footer/update-footer" element={<ProtectedRoutes component={FooterInfoUpdate} />} />
            {/* Footer management end */}

            {/* newsletter management start */}
            <Route path="/newsletter/newsletter-list" element={<ProtectedRoutes component={NewsLettersList} />} />
            {/* newsletter management end */}

            {/* newsletter management start */}
            <Route path="/contact/list-contact" element={<ProtectedRoutes component={AllContactMessages} />} />
            {/* newsletter management end */}

            {/* order management start */}
            <Route path="/orders/list-orders" element={<ProtectedRoutes component={OrderList} />} />
            <Route path="/orders/view-order/:id" element={<ProtectedRoutes component={OrderDetails} />} />
            <Route path="/about/update-about" element={<ProtectedRoutes component={UpdateAbout} />} />
            {/* order management end */}

          </Route>
        </Routes>
      </BrowserRouter>
      <ToastContainer autoClose={2000} />
    </>
  );
}

export default App;
